/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  AiPremiumModelUsage
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Get daily premium model usage
 */
export const getPremiumModelUsage = (

 signal?: AbortSignal
) => {


      return axiosClient<AiPremiumModelUsage>(
      {url: `/ai/premium_model_usage`, method: 'GET', signal
    },
      );
    }




export const getGetPremiumModelUsageQueryKey = () => {
    return [
    'ai','premium_model_usage'
    ] as const;
    }


export const getGetPremiumModelUsageQueryOptions = <TData = Awaited<ReturnType<typeof getPremiumModelUsage>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPremiumModelUsage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPremiumModelUsageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPremiumModelUsage>>> = ({ signal }) => getPremiumModelUsage(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPremiumModelUsage>>, TError, TData>
}

export type GetPremiumModelUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getPremiumModelUsage>>>
export type GetPremiumModelUsageQueryError = ErrorType<void>


/**
 * @summary Get daily premium model usage
 */

export function useGetPremiumModelUsage<TData = Awaited<ReturnType<typeof getPremiumModelUsage>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPremiumModelUsage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPremiumModelUsageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






